import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gk-user-form-redirect-modal',
  templateUrl: './user-form-redirect-modal.component.html',
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserFormRedirectModalComponent {
  @Input() forceAddressEdit: boolean;

  constructor(
    public ngbActiveModal: NgbActiveModal,
    @Inject('window') private window: Window,
  ) {}

  redirectToEditUserForm(): void {
    this.window.open(
      `/pz/user-form?redirectUrl=${this.window.location.href}`,
      '_self',
    );
  }
}
